import { render, staticRenderFns } from "./ProductSimple.vue?vue&type=template&id=3c6ec8ae&"
import script from "./ProductSimple.vue?vue&type=script&lang=js&"
export * from "./ProductSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports